<!--消费记录-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">消费记录</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="消费日报" name="first">
        <DayReports></DayReports>
      </el-tab-pane>
      <el-tab-pane label="消费月报" name="second">
        <MonthReports></MonthReports>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import DayReports from '@/components/client/DayReports'
  import MonthReports from '@/components/client/MonthReports'
  export default {
    components: {
      DayReports,
      MonthReports
    },
    data () {
      return {
        activeName: 'first'
      }
    }
  }
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/client/ExpensesRecord.vue